import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Model from '@/plugins/sdk/resources/Asset/Manufacturer/Model'
import Event from '@/plugins/sdk/resources/Asset/Event'
import Branch from '@/plugins/sdk/resources/Dictionary/BusinessBranch'

export const STATUS_ALLOCATED = 'allocated'
export const STATUS_IN_STOCK = 'in stock'
export const STATUS_WARRANTY = 'warranty'
export const STATUS_BROKEN = 'broken'

export default class extends Resource {
  static name = 'asset'
  static label = 'serial'

  static get fields () {
    return {
      id: new UUID(),
      serial: new STRING(),
      status: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      manufacturer_model: new ITEM(Model),
      branch: new ITEM(Branch),
      events: new COLLECTION(Event)
    }
  }
}
